import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { ProductImageFilter } from '@shared/app/scripts/filters/product-image';

export type SkuImageFilter = (input: {
  articleCode: string;
  image: string;
}) => any;

interface ISkuImage {
  transform: SkuImageFilter;
}

/**
 * Returns URL of the image available for the SKU
 * @param Sku information
 * @return Image URL
 */
@Pipe({ name: 'skuImage' })
export class SkuImagePipe implements PipeTransform, ISkuImage {
  constructor(private productImageFilter: ProductImageFilter) {
    'ngInject';
  }

  public transform(input: { articleCode: string; image: string }): any {
    return input.image
      ? `http://${input.image}`
      : this.productImageFilter(input.articleCode, 'large');
  }
}
